// componnet
import StoreSearch from "../components/storeSearch/StoreSearch";
export default function StoreSearchtPage() {
  return <StoreSearch></StoreSearch>;
}
